import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { ReportsDailyActiveUse } from '../../containers/reports/ReportsDailyActiveUse';

export const AdminReportsDailyPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<ReportsDailyActiveUse />
		</AdminDashboardPageLayout>
	);
};
